import { ReactNode } from 'react'

export type Props = {
  color: string
  borderColor: string
  icon?: ReactNode
  statusBadgeColor?: string
  hideTail?: boolean
}

const MarkerSmall = ({ color, borderColor, icon, statusBadgeColor, hideTail }: Props) => {
  return <div style={{
    position: 'relative',
    width: '20px',
    height: hideTail ? '20px' : '28px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: '8px'
  }}>
    <div style={{
      width: '20px',
      height: '20px',
      backgroundColor: color,
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: `2px solid ${borderColor}`,
      zIndex: 2,
      position: 'relative'
    }}>
      <div style={{
        width: '14px',
        height: '14px',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        {icon}
      </div>
    </div>
    {statusBadgeColor && (
      <div style={{
        position: 'absolute',
        top: '0px',
        right: '0px',
        width: '8px',
        height: '8px',
        backgroundColor: statusBadgeColor,
        borderRadius: '50%',
        border: '1px solid white',
        zIndex: 3
      }} />
    )}
    {!hideTail && (
      <div style={{
        width: '12px',
        height: '12px',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        clipPath: 'polygon(50% 100%, 0 0, 100% 0)',
        marginTop: '-3px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
        zIndex: 1
      }} />
    )}
  </div>
}

export default MarkerSmall